import { Link } from "react-router-dom";
import { ShieldOff } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { homeFor } from "@/lib/permissions";
import { Button } from "@/components/ui/button";

export default function ForbiddenPage() {
  const { user } = useAuth();
  return (
    <div data-testid="forbidden-page" className="panel p-10 max-w-md mx-auto mt-10 flex flex-col items-center text-center gap-3">
      <ShieldOff className="h-8 w-8 text-red-400" />
      <h1 className="text-lg font-bold">Accès refusé</h1>
      <p className="text-xs text-muted-foreground">Votre rôle « {user?.role} » ne permet pas d'accéder à ce module.</p>
      <Button asChild size="sm" data-testid="forbidden-home-link"><Link to={homeFor(user?.role)}>Retour à mon espace</Link></Button>
    </div>
  );
}
